<template>
  <div>
    <div class="filter-container" v-if="showQuery">
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="isMB?11:16">
          <span class="span-top-text">查询条件</span>
          <!-- <el-button
            size="mini"
            :icon="showForm?'el-icon-arrow-up':'el-icon-arrow-down'"
            @click="showForm = !showForm"
            style="margin-left:10px;"
            class="searchIcon"
          />-->
          <div class="searchIcon" @click="showForm = !showForm">
            <i :class="showForm?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
          </div>
        </el-col>
        <el-col :span="isMB?13:8">
          <div class="btn-search">
            <el-button
              size="mini"
              type="primary"
              @click="query()"
              :disabled="!canSearch"
            >查询</el-button>
            <el-button size="mini" type="primary" plain @click="resetQuery" v-if="showReset">重置</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row v-show="showForm">
        <el-divider style="margin:0px;"></el-divider>
        <el-form class="form-item" @keyup.enter.native="query()" size="mini">
          <slot name="query"></slot>
        </el-form>
      </el-row>
    </div>
    <span id="barTip" v-if="barTip">{{barTip}}</span>
    <div v-if="showToolbar" class="filter-container" style="border-bottom: 0;margin-bottom: 0;">
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="isMB?9:6">
          <slot name="toolbar-left">
            <span v-if="showQuery" class="span-top-text">查询结果</span>
          </slot>
        </el-col>
        <el-col :span="isMB?15:18">
          <div style="text-align: right;">
            <slot name="toolbar-right"></slot>
          </div>
        </el-col>
      </el-row>
    </div>
    <slot name="list" :data="data">
      <el-table
        ref="table"
        :data="data"
        :size="size"
        :max-height="maxHeight"
        :show-summary="showSummary"
        :show-header="showHeader"
        highlight-current-row
        :row-key="rowKey"
        :stripe="showStripe"
        :border="border"
        :loading="loading"
        :class="showTreeSelect?'tree-table':isTree?'parent-table':''"
        @selection-change="onCheckChange"
        :default-expand-all="expandAllRow"
        :expand-row-keys="expands"
        style="width: 100%;margin-bottom: 20px;"
        :row-style="{height:'40px'}"
        :cell-style="{padding:'0px'}"
        @sort-change="onSortChange"
      >
        <el-table-column fixed v-if="showCheckbox" type="selection" :selectable="selectable" align="center" width="40" />
        <el-table-column v-if="showTreeSelect" type="index" align="center" width="45">
          <template #header>
            <el-checkbox
              :indeterminate="topInd(topRow)"
              v-model="topRow.Checked"
              @change="handleSelect(topRow)"
            ></el-checkbox>
          </template>
          <template slot-scope="{row}">
            <el-checkbox
              :indeterminate="rowInd(row)"
              v-model="row.Checked"
              @change="handleSelect(row)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="table"></slot>
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </el-table>
    </slot>
    <!-- 分页 -->
    <el-pagination
      v-if="page"
      style="margin-top: 5px;display:inline-block;width:95%;text-align:center;"
      :page-size.sync="pageParams.pageSize"
      :page-sizes="[10,20,50,100]"
      :current-page.sync="pageParams.pageIndex"
      :layout="isMB?MBpageLayout:pageLayout"
      :total="listTotal"
      @size-change="onPageSizeChange"
      @current-change="onPageIndexChange"
    />
    <van-button v-if="$store.state.isMB&&page" @click="showPage=true" size="small" class="pageBn">
      第 {{pageParams.pageIndex}} 页
      <van-icon class="pageIcon" name="arrow-down" />
    </van-button>
    <van-popup v-model="showPage">
      <van-picker
        style="width:300px;"
        :columns="columns"
        @confirm="changePage"
        :default-index="0"
        show-toolbar
        @cancel="showPage=false"
        cancel-button-text="取消"
        confirm-button-text="确认"
        visible-item-count="3"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    rowKey: {
      type: String,
      default: undefined,
    },
    showStripe: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: true,
    },
    maxHeight: {
      type: String,
      default: "-",
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    showHeader: { type: Boolean, default: true },
    showQuery: {
      type: Boolean,
      default: false,
    },
    showToolbar: {
      type: Boolean,
      default: true,
    },
    expandAllRow: {
      type: Boolean,
      default: false,
    },
    expandRowKeys: {
      type: Array,
      default: () => [],
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    showReset: {
      type: Boolean,
      default: true,
    },
    canSearch: {
      type: Boolean,
      default: true,
    },
    /*
    需要设置 list 的 sourceData 为源数据
    树形数据需要有 Checked 字段    
    */
    showTreeSelect: {
      type: Boolean,
      default: false,
    },
    //是否树形结构
    isTree: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "mini",
    },
    unit: {
      type: String,
      default: "记录",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    queryParams: {
      type: Object,
      defalut: () => ({}),
    },
    localDelete: {
      type: Boolean,
      default: false,
    },
    deleteConfirmText: {
      type: String,
      default: undefined,
    },
    confirmOnDelete: {
      type: Boolean,
      default: true,
    },
    deleteHelpMessage: {
      type: String,
      default: "",
    },
    page: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Function,
      default: () => {
        return true
      }
    },
    /** getDataFunc 属性介绍
     ** 接收一个查询条件的json对象，然后返回promise的函数，resolve的数据必须有一个字段为data的数组，如下
     ** 注：此属性如果有设置，则getListFunc、getPageListFunc、getPageListWithSummaryFunc函数都不起效
     ** getDataFunc = (params) => {
     **   return new Promise((resolve, reject) => {
     **     //无分页时
     **     resolve({
     **       data: []
     **     });
     **      //有分页时
     **     resolve({
     **       data: {list:[],total:0}
     **     });
     **   });
     ** };
     **/
    getDataFunc: {
      type: Function,
      default: null,
    },

    /** deleteFunc 属性介绍
     ** 接收一个id值，返回promise的函数，resolve的数据，reject最好有一个message字段，如下
     ** deleteFunc = (id) => {
     **   return new Promise((resolve, reject) => {
     **     //成功时
     **     resolve();
     **
     **     //失败时
     **     reject({
     **       message:"删除失败！"
     **     })
     **   });
     ** };
     */
    deleteFunc: {
      type: Function,
      default: null,
    },
    pageLayout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    pageSize: {
      type: Number,
      default: undefined,
    },
    barTip: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      data: [],
      sourceData: [],
      expands: [],
      total: 0,
      loading: false,
      checkedRows: [],
      showForm: !this.$store.state.isMB,
      initParams: {},
      pageParams: {
        pageSize: this.pageSize || this.$store.state.sys.pageSize, //分页大小
        pageIndex: 1,
      },
      //查询参数
      tempQueryParams: {},
      initQueryParams: {},
      orderParams: {
        SortName: "", //排序字段
        SortOrder: "", //排序顺序 降序：desc 升序：asc
      },
      isMB: this.$store.state.isMB,
      showPage: false,
      columns: [],
      MBpageLayout: "total, sizes",
    };
  },
  mounted() {
    this.initQueryParams = { ...this.queryParams };
    this.tempQueryParams = { ...this.queryParams };
  },
  computed: {
    listTotal() {
      if (this.page) {
        return this.total;
      }
      return this.data.length;
    },
    topRow() {
      return {
        Checked: false,
        children: this.data,
      };
    },
  },
  methods: {
    setExpands(data) {
      this.expands = data;
      // console.log(this.expands);
    },
    // tableRowClassName({ row, rowIndex }) {
    //   console.log("111111");
    //   return this.rowClassNameFunc({ row, rowIndex });
    // },
    onCheckChange(valueArrary) {
      this.checkedRows = valueArrary;
      this.$emit("check-change", valueArrary);
    },
    //获取选中的行
    getCheckedRows() {
      if (this.showTreeSelect) {
        let checkedRow = this.sourceData.filter((item) => item.Checked == true);
        return checkedRow;
      } else {
        return this.checkedRows;
      }
    },
    //查询方法
    query(params = null) {
      if (params != null) {
        for (let key in params) {
          this.queryParams[key] = params[key];
        }
      }
      this.tempQueryParams = { ...this.queryParams };
      this.pageParams.pageIndex = 1;
      return this.getData();
    },
    //重置查询条件
    resetQuery() {
      for (let key in this.queryParams) {
        this.queryParams[key] = this.initQueryParams[key];
      }
      // console.log("reset");
      this.$emit("reset");
      return this.query();
    },
    onSortChange({ prop, order }) {
      // console.log(prop, order);
      this.orderParams.SortOrder =
        order == "descending" ? "desc" : order == "ascending" ? "asc" : "";
      this.orderParams.SortName = order == null ? null : prop;
      this.getData();
    },
    getData(initParams = null) {
      if (initParams != null) {
        this.clear();
        this.initParams = { ...initParams };
        return this.resetQuery();
      }
      let params = {};
      if (this.page) {
        params = { ...this.pageParams };
      }
      params = {
        ...params,
        ...this.tempQueryParams,
        ...this.initParams,
        ...this.orderParams,
      };
      params = this.$commonJs.obj.removeNullKey(params);
      this.loading = true;

      let getDataFunc = null;
      if (this.getDataFunc) {
        getDataFunc = this.getDataFunc;
      } else {
        alert("请指定list组件里get-data-func属性！");
        return false;
      }

      return new Promise((resolve, reject) => {
        getDataFunc(params)
          .then((res) => {
            if (!this.disabled) {
              // console.log(res);
              if (res.Code != 401) {
                if (res.Data instanceof Array) {
                  this.data = res.Data;
                  if (this.page) {
                    this.total = res.Count;
                    let times = Math.ceil(res.Count / this.pageParams.pageSize);
                    if (times == 0) {
                      times = 1;
                    }
                    this.columns = [];
                    for (var i = 0; i < times; i++) {
                      this.columns.push("第 " + (i + 1) + " 页");
                    }
                  } else {
                    this.total = res.Data.length;
                  }
                } else {
                  alert("找不到数据列表，请在data字段或者data.list字段赋值！");
                }
              }
            } else {
              this.$commonJs.showMessage("未授权");
            }
            this.hasGetData = true;
            this.loading = false;
            resolve({ list: this.data, total: this.total });
            // this.$emit("loaded",res.Data)
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    _delete(func, data, rows, message) {
      return new Promise((resolve, reject) => {
        let promise;
        if (this.confirmOnDelete) {
          promise = this.$confirm(message, "删除确认", {
            type: "warning",
          });
        } else {
          promise = Promise.resolve();
        }
        return promise
          .then(() => {
            this.loading = true;
            func(data)
              .then((res) => {
                // console.log(res);
                if (res.Code != undefined && res.Code != 0) {
                  this.$message.warning(res.Msg);
                  this.loading = false;
                  return;
                }
                if (this.page) {
                  this.getData();
                } else {
                  if (!(rows instanceof Array)) {
                    rows = [rows];
                  }
                  rows.forEach((item) => {
                    let rowIndex = this.data.indexOf(item);
                    if (rowIndex > -1) {
                      this.data.splice(rowIndex, 1);
                    }
                  });
                  this.loading = false;
                }
                this.$emit("deleted");
                if (this.confirmOnDelete) {
                  this.$message.success("删除成功");
                }
                resolve(res);
              })
              .catch((err) => {
                this.loading = false;
                reject(err);
              });
          })
          .catch((res) => {});
      });
    },
    delete(row = null) {
      // row = row || this.getCheckedRowWithMessage();
      if (!row) {
        return false;
      }
      let deleteFunc;
      if (this.localDelete) {
        deleteFunc = Promise.resolve();
      } else {
        if (!this.deleteFunc) {
          alert("请在list组件中指定delete-func属性");
          return false;
        } else {
          deleteFunc = this.deleteFunc;
        }
      }

      let text =
        "您确定要删除这个" + this.unit + "吗？" + this.deleteHelpMessage;
      if (this.deleteConfirmText) {
        text = this.deleteConfirmText;
      }
      return this._delete(deleteFunc, row[this.rowKey], [row], text);
    },
    reload() {
      return this.getData();
    },
    clear() {
      this.total = 0;
      this.data = [];
    },
    //分页容量大小发生变化时
    onPageSizeChange(value) {
      // this.pageParams.pageSize = value;
      this.getData();
    },
    //
    onPageIndexChange(pageIndex) {
      // this.pageParams.currentPage = pageIndex;
      this.getData();
    },
    changePage(e) {
      // console.log("pageNo", e.length);
      if (e.length == 5) {
        this.pageParams.pageIndex = Number(e[2]);
      } else if (e.length == 6) {
        this.pageParams.pageIndex = Number(e[2] + e[3]);
      }
      this.showPage = false;
      this.getData();
    },
    handleSelect(row) {
      if (row.Pid != undefined && row.Pid != 0) {
        this.setParent(row.Pid);
      }
      if (row.children) {
        this.setChild(row.children, row.Checked);
      }
    },
    setParent(pid) {
      let parent = this.sourceData.find((item) => item.DpId == pid);
      if (parent) {
        parent.Checked = parent.children.every((s) => s.Checked);
        if (parent.Pid != 0) {
          this.setParent(parent.Pid);
        }
      }
    },
    setChild(data, value) {
      data.forEach((item) => {
        item.Checked = value;
        if (item.children) {
          this.setChild(item.children, value);
        }
      });
    },
    topInd(row) {
      if (this.sourceData.every((item) => item.Checked)) {
        row.Checked = true;
        return false;
      } else {
        row.Checked = false;
        if (this.sourceData.some((item) => item.Checked)) {
          return true;
        } else {
          return false;
        }
      }
    },
    rowInd(item) {
      if (item.children) {
        if (item.children.every((o) => o.Checked)) {
          return false;
        } else {
          if (item.children.some((o) => o.Checked)) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
.searchIcon {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #aaa;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  margin-left: 4px;
  @media screen and (min-width: 768px) {
    &:hover {
      cursor: pointer;
      color: #fff;
      background: #409eff;
    }
  }

  i {
    transition-duration: 0.2s;
  }
  .el-icon-arrow-down {
    vertical-align: -1px;
  }
}
.pageBn {
  height: 29px;
  vertical-align: -4px;
  width: 90px;
  font-size: 14px;
  .pageIcon {
    vertical-align: -2px;
    margin-right: -5px;
  }
}
.el-pagination {
  @media screen and (max-width: 767px) {
    margin-left: 5%;
  }
}
#barTip {
  color: #f11;
  font-size: 14px;
  margin: 0px 0 5px;
  display: inline-block;
}
</style>